import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Qs from "qs";
import uweb from "vue-uweb";
import "@/plugins/sensors";
import { thisFire } from "./plugins/firebase";
import "vant/lib/index.css";
import {
  Popup,
  Picker,
  DatetimePicker,
  Toast,
  List,
  Cell,
  Icon,
  Search,
  RadioGroup,
  Radio
} from "vant";
import vueSwiper from "vue-awesome-swiper";

const uwebOptions = {
  siteId: "1279379736",
  debug: process.env.VUE_APP_TITLE === "development",
  autoPageview: false,
};
Toast.setDefaultOptions({ duration: 4500, forbidClick: false });
Vue.use(Popup);
Vue.use(Picker);
Vue.use(DatetimePicker);
Vue.use(Toast);
Vue.use(List);
Vue.use(Cell);
Vue.use(Icon);
Vue.use(Search);
Vue.use(vueSwiper);
Vue.use(uweb, uwebOptions);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.config.productionTip = false;
Vue.prototype.$bus = new Vue();
Vue.prototype.$qs = Qs;
Vue.prototype.$fireBase = thisFire;

Vue.directive("sa", {
  bind: function(el, binding) {
    const properties = binding.value;
    el.addEventListener("click", () => {
      /* for (let i in properties) {
                this.track(i, properties[i]);
            }*/
    });
  },
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#main");
